/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import ButtonComponent from "./BasicInputs/ButtonComponent.jsx";
import {Socket} from "../Socket.js";
import Console from "./Console.jsx";
import {Util} from "../Utilities.js";
import {Subscription} from "../Subscription.js";
import TextInput from "./BasicInputs/TextInput.jsx";

class LiveConsole extends Component {
    constructor() {
        super();

        this.state = {
            sessionId: Util.unique.newGlobalId(),
            logs: [],
            input: "",
            currentPath: "/home"

        }
        this.sub = new Subscription()


    }

    fetchData() {
        let {sessionId} = this.state

        this.sub.add(() => Socket.subscribe(`console-${sessionId}`, (data) => {
            console.log(data);
            if (data.type === "newLine") {
                this.setState((state) => {
                    let logs = state.logs ?? []
                    logs.push(data.data)
                    return {logs: logs}

                })
            }

            if (data.type === "done") {
                this.setState((state) => {
                    return {currentPath: data.directory}
                })

            }
        }), "liveData")

    }

    componentDidMount() {
        this.fetchData()
    }

    componentWillUnmount() {
        this.sub.unmount()
    }


    shell(command) {

        let {nodeId} = this.props
        let {sessionId, currentPath} = this.state

        Socket.emit(`console-${sessionId}`, {
            type: "command",
            nodeId: nodeId,
            subSystem: "none",
            command: command,
            currentPath: currentPath
        })

    }


    render() {
        let {sessionId, input} = this.state

        let {nodeId} = this.props

        return (
            <div className={"bg-stone-900 rounded"}>
                <Console logs={this.state.logs} titel={"Live Console"}/>


                <div className={"flex flex-wrap gap-2 p-1"}>
                    <ButtonComponent text={"List Containers"}
                                     onClick={() => {
                                         this.shell("docker ps -a")
                                     }}
                    />

                    <ButtonComponent text={"Client logs"}
                                     onClick={() => {
                                         this.shell("journalctl -u edgeClient ")
                                     }}
                    />
                    <ButtonComponent text={"Client status"}
                                     onClick={() => {
                                         this.shell("systemctl status edgeClient ")
                                     }}
                    />
                    <ButtonComponent text={"Webserver Logs"}
                                     onClick={() => {
                                         this.shell("docker logs reverse-proxy")
                                     }}
                    />
                    <ButtonComponent text={"Webserver Config"}
                                     onClick={() => {
                                         this.shell("docker exec reverse-proxy cat /rpxy/config/rpxy.toml")
                                     }}
                    />


                    <ButtonComponent text={"List Certificates"}
                                     onClick={() => {
                                         this.shell("cd edgeClient/proxy/certs && ls")
                                     }}
                    />
                    <ButtonComponent text={"List Claims "}
                                     onClick={() => {
                                         this.shell("cd /home/edgeClient/nginx/html/.well-known/acme-challenge/ && ls")
                                     }}
                    />


                </div>
                <div className={"p-1"}>
                    <TextInput
                        value={input}
                        onChange={(newValue) => {
                            this.setState({input: newValue})
                        }}
                        onKeyDown={(event) => {
                            if (event.code === "Enter") {
                                this.shell(input)
                                this.setState({input: ""})
                            }
                        }}
                    />

                </div>


            </div>
        );
    }
}

LiveConsole.propTypes = {};

LiveConsole.defaultProps = {};


export default LiveConsole;